module.exports = "/static/assets/810b3e67978393f7cb2635e41e07d538.png";